import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Space } from "antd";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootDispatch } from "../../app/store";
import { EditableList } from "../../compnents/list/EditableList";
import { NavBar } from "../../compnents/nav/NavBar";
import { GetDepartmentListParams } from "../../services/department";
import { ThemeContext } from "../../theme/ThemeContext";
import { columns } from "./columns";
import { DepartmentModal } from "./DepartmentModal";
import {
  getDepartmentList,
  selectDepartmentPage,
  toggleDepartmentState,
} from "./departmentSlice";

interface DepartmentsProps {
  onChange?: (id: string) => void;
}

export const Departments = ({ onChange }: DepartmentsProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();

  const theme = useContext(ThemeContext);

  const [form] = Form.useForm();

  const { tenantId } = useParams<{ tenantId: string | undefined }>();

  const page = useSelector(selectDepartmentPage);

  const [params, setParams] = useState<GetDepartmentListParams>({
    current: 1,
  });

  const [departmentId, setDepartmentId] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    dispatch(getDepartmentList({ ...params, tenantId }));
  }, [dispatch, params, tenantId]);

  return (
    <Col
      style={{
        position: "relative",
        height: tenantId ? "calc(100% - 20px)" : "calc(100% - 30px)",
        overflow: "hidden",
        marginTop: 10,
        marginBottom: tenantId ? 0 : 10,
        marginLeft: tenantId ? 30 : 0,
        marginRight: tenantId ? 30 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {tenantId ? (
        <NavBar
          where={["机构管理", "科室管理"]}
          backtrace={{
            name: "机构管理",
            path: "/admin/tenant",
          }}
          style={{ marginBottom: 10 }}
          buttons={[
            <Button
              key="0"
              type="primary"
              icon={<PlusOutlined />}
              size="small"
              onClick={() => setIsModalVisible(true)}
            >
              新增
            </Button>,
          ]}
        />
      ) : (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          size="small"
          style={{
            position: "fixed",
            top: 78,
            right: 45,
          }}
          onClick={() => setIsModalVisible(true)}
        >
          新增
        </Button>
      )}
      <Col
        style={{
          backgroundColor: theme.pn,
          borderRadius: 10,
          padding: "10px 15px 0 15px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Form
          form={form}
          autoComplete="off"
          onFinish={(values) => setParams({ ...params, ...values, current: 1 })}
        >
          <Row
            align="middle"
            justify="space-between"
            style={{ marginBottom: 20, marginTop: 10 }}
          >
            <Space>
              <Form.Item name="name" noStyle>
                <Input
                  placeholder="请输入科室名称"
                  style={{ width: 315 }}
                  prefix={<SearchOutlined color={theme.tc3} />}
                  allowClear
                  onChange={form.submit}
                />
              </Form.Item>
            </Space>
            <Button type="primary" onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>
        <EditableList
          page={page}
          columns={columns((d) => {
            dispatch(
              toggleDepartmentState({ departmentId: d.id, tenantId })
            ).then(() => setParams({ ...params, current: 1 }));
          }, page.size * (page.current - 1))}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size });
          }}
          onRow={(d) => ({
            onDoubleClick: () => {
              setDepartmentId(d.id);
              setIsModalVisible(true);
            },
          })}
        />
      </Col>
      <DepartmentModal
        departmentId={departmentId}
        visible={isModalVisible}
        onCancel={() => {
          setDepartmentId("");
          setIsModalVisible(false);
        }}
        onOk={() => {
          onChange && onChange(departmentId);
          setDepartmentId("");
          setIsModalVisible(false);
          setParams({ ...params, current: 1 })
        }}
      />
    </Col>
  );
};
